import useBrazilianRealEstateFundIssuer from "components/company/v3/context/hooks/useBrazilianRealEstateFundIssuer";
import { FormattedMessage } from "react-intl";

export default function FiisExternalLinks() {
  const { website, fundosNetHref, managementReport } = useBrazilianRealEstateFundIssuer();

  return (
    <>
      <div className="hidden divide-x divide-gray-200 *:px-2 first:*:pl-0 last:*:pr-0 lg:flex">
        {managementReport && managementReport.linkHref && (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={managementReport.linkHref}
            className="text-sm font-medium text-blue-600 hover:underline"
          >
            <span>
              <FormattedMessage defaultMessage="Relatório Gerencial" id="gPZvf6" />
            </span>
          </a>
        )}

        {website && (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={website}
            className="text-sm font-medium text-blue-600 hover:underline"
          >
            <span>
              <FormattedMessage defaultMessage="Site do Fundo" id="2euywa" />
            </span>
          </a>
        )}

        {fundosNetHref && (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={fundosNetHref}
            className="text-sm font-medium text-blue-600 hover:underline"
          >
            <span>
              <FormattedMessage defaultMessage="Arquivos" id="7ahQI4" />
            </span>
          </a>
        )}
      </div>

      <div className="flex flex-col items-center gap-3 *:px-2 first:*:pl-0 last:*:pr-0 lg:hidden">
        {managementReport && managementReport.linkHref && (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={managementReport.linkHref}
            className="text-sm font-medium text-blue-600 hover:underline"
          >
            <span>
              <FormattedMessage defaultMessage="Relatório Gerencial" id="gPZvf6" />
            </span>
          </a>
        )}

        <div className="flex divide-x divide-gray-200">
          {website && (
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={website}
              className="text-sm font-medium text-blue-600 hover:underline"
            >
              <span>
                <FormattedMessage defaultMessage="Site do Fundo" id="2euywa" />
              </span>
            </a>
          )}

          {fundosNetHref && (
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={fundosNetHref}
              className="text-sm font-medium text-blue-600 hover:underline"
            >
              <span>
                <FormattedMessage defaultMessage="Arquivos" id="7ahQI4" />
              </span>
            </a>
          )}
        </div>
      </div>
    </>
  );
}
